export const Minus = ({ color = "#D6D6D6" }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <path d="M4.16675 10.4H15.8334" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

}